module.exports = __webpack_public_path__ + "static/blog-dcc95c7b2129647ba9f168c479cbcbd6.jpg";